import { allValues, Rights } from '../rights';

export const BUILDING_SERVICES_RIGHTS = Object.freeze([
  Rights.RESIDENTS.READ.key,
  Rights.RESIDENTS.WRITE.key,
  Rights.RESIDENTS.GENERAL.READ.key,
  Rights.RESIDENTS.CONTRACT.READ.key,
  ...allValues(Rights.RESIDENTS.CHECKLIST),
  ...allValues(Rights.RESIDENTS.CONTACTS),
  Rights.RESIDENTS.CONSULTATION.READ.key,
  ...allValues(Rights.RESIDENTS.UTILS),
  Rights.GENERAL.CALENDAR.READ.key,
  Rights.GENERAL.CALENDAR.WRITE.key,
  Rights.GENERAL.CONTACTS.READ.key,
  Rights.LISTS.READ.key,
  Rights.LISTS.WRITE.key,
  ...allValues(Rights.GENERAL.MESSAGES),
  Rights.ROSTER.ACCESS.LIMITED_READ.key,
  Rights.ROSTER.VACATION_SCHEDULE.READ.key,
]);
